// automationFieldUtils.js

import {
  getChecklistTemplateItemLabel,
  normalizeChecklistTemplateItems,
} from 'utilities/ChecklistTemplateItems';
import { getOptionLabel, resolveEnumOptionsForField } from 'utilities/EnumOptions';

export const getFieldKey = (field) => {
  const name = String(field?.name || field?.key || '').trim();
  return name || '';
};

export const getFieldLabel = (field) => {
  const label = String(field?.label || '').trim();
  return label || getFieldKey(field);
};

export const normalizeFieldEnumOptions = (field) => {
  return resolveEnumOptionsForField(field, 'en')
    .map((option) => ({
      value: String(option?.value || ''),
      label: getOptionLabel(option, 'en') || String(option?.value || ''),
    }))
    .filter((option) => option.value);
};

/**
 * Template item options for checklist condition item pickers (value = stable key).
 *
 * @param {object|null|undefined} field
 * @returns {Array<{ value: string, label: string }>}
 */
export const normalizeFieldChecklistItemOptions = (field) => {
  if (String(field?.type || '').trim().toLowerCase() !== 'checklist') return [];

  return normalizeChecklistTemplateItems(field?.checklistItems)
    .map((item) => ({
      value: String(item?.key || '').trim(),
      label: getChecklistTemplateItemLabel(item) || String(item?.key || '').trim(),
    }))
    .filter((option) => option.value);
};

export const isEmailBulletFieldOption = (field) => {
  const key = String(field?.key || field?.name || '').trim().toLowerCase();
  const type = String(field?.type || '').trim().toLowerCase();
  const label = String(field?.label || '').trim().toLowerCase();

  const hasBlockedToken = (value) => (
    value.includes('comment') || value.includes('activity')
  );

  if (!key) return false;
  if (type === 'tags' || type.includes('comment') || type.includes('activity')) return false;
  if (key === 'tags') return false;
  if (hasBlockedToken(key)) return false;
  if (hasBlockedToken(label)) return false;

  return true;
};
